import React, { ReactElement } from "react";
import { SvgIconProps, Theme, Typography } from "@mui/material";
import DollarIcon from "@icons/myicons/dollar-cash-circle.svg?react";
import ChartIcon from "@icons/myicons/chart-square.svg?react";
import ShieldIcon from "@icons/myicons/shield-protected-checkmark.svg?react";
import { toPercent } from "@helpers";
import { AssetsChartDataName } from "./types";

interface AssetsChartTagProps {
  name: AssetsChartDataName;
  percent: number;
  theme: Theme;
}

const assetsChartTagIconMapper: {
  [key in AssetsChartDataName]: ReactElement<SvgIconProps>;
} = {
  insurances: <ShieldIcon />,
  cash: <DollarIcon />,
  investments: <ChartIcon />,
};

export const AssetsChartTag = (props: AssetsChartTagProps) => {
  const { percent, name, theme } = props;

  const value = toPercent(percent / 100, "auto", 0, 0);
  const IconByName = assetsChartTagIconMapper[name];

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        background: theme.palette.background.tooltipPrimary,
        color: theme.palette.text.onTooltipPrimary,
        borderRadius: "4px",
        padding: "4px",
        gap: "4px",
      }}
    >
      {IconByName}

      <Typography variant="body3" style={{ margin: 0 }}>
        {value}
      </Typography>
    </div>
  );
};
